module.exports = __webpack_public_path__ + "img/image-thumb-8.de331ee8.jpg";